var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlackoutPeriodForm',{on:{"submit":function($event){return _vm.onSubmit($event)},"submit-recurring":function($event){return _vm.onSubmitRecurring($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }